import React from "react";
import * as Tooltip_ from "@radix-ui/react-tooltip";

export const Tooltip = ({ children, msg }: any) => {
  return (
    <Tooltip_.Provider delayDuration={200}>
      <Tooltip_.Root>
        <Tooltip_.Trigger asChild>
          {children}
        </Tooltip_.Trigger>

        <Tooltip_.Portal>
          <Tooltip_.Content
            className="max-w-xs px-3 py-2 bg-gray-800 bg-opacity-95 text-white text-xs font-medium rounded-md shadow-md z-50
              data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade 
              data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade 
              data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade 
              data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade
              will-change-[transform,opacity]"
            sideOffset={5}
          >
            {msg}
            <Tooltip_.Arrow className="fill-gray-800 fill-opacity-95" width={10} height={5} />
          </Tooltip_.Content>
        </Tooltip_.Portal>
      </Tooltip_.Root>
    </Tooltip_.Provider>
  );
};
